import { render } from "./SearchValues.vue?vue&type=template&id=5f79ed38&scoped=true&ts=true"
import script from "./SearchValues.vue?vue&type=script&lang=ts"
export * from "./SearchValues.vue?vue&type=script&lang=ts"

import "./SearchValues.vue?vue&type=style&index=0&id=5f79ed38&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f79ed38"]])

export default __exports__